export enum AspectRatio {
    Ratio_16_9 = '16-9'
}
